/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { Badge as BadgeType } from '@wit/vtv-x-foundation-lib';
import Badge from './Badge';

interface Props {
  badges: BadgeType[];
  className?: string;
  bemBlock: string;
}

const BADGES_LIMIT_TO_DISPLAY = 3;

export default function BadgesGroup({ badges = [], className = '', bemBlock }: Props): JSX.Element | null {
  const getBadgeText = (text: string[] | string | undefined) => {
    if (!text) {
      return <> </>;
    }

    if (Array.isArray(text)) {
      return text.map((el, index) => {
        const key = `${bemBlock}_badgeText___${index}`;
        if (index % 3 === 1) {
          return (
            <>
              <span key={key} id={key} className="badge string-concatenator" />
              <span>{el}</span>
            </>
          );
        }
        return (
          <span id={key} key={key}>
            {el}
          </span>
        );
      });
    }

    return <span id={`${bemBlock}_badgeText`}>{text}</span>;
  };

  const badgesElements = badges.map((badge, index) => {
    if (index >= BADGES_LIMIT_TO_DISPLAY) {
      return null;
    }

    if (index === badges.length - 1 || index === BADGES_LIMIT_TO_DISPLAY - 1) {
      return (
        <div className="last-badge-container" key={badge.icon}>
          <Badge badge={badge} bemBlock={bemBlock} />
          <span className="badge-text">{getBadgeText(badge.label)}</span>
        </div>
      );
    }
    return <Badge badge={badge} bemBlock={bemBlock} key={badge.icon} />;
  });

  return <div className={`badges-group-container ${className}`}>{badgesElements.length ? badgesElements : <></>}</div>;
}
